import { render, staticRenderFns } from "./list_happiness_tips_categories_component.vue?vue&type=template&id=642f2946&scoped=true"
import script from "./list_happiness_tips_categories_component.vue?vue&type=script&lang=js"
export * from "./list_happiness_tips_categories_component.vue?vue&type=script&lang=js"
import style0 from "./list_happiness_tips_categories_component.vue?vue&type=style&index=0&id=642f2946&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f2946",
  null
  
)

export default component.exports